module.exports = __webpack_public_path__ + "media/images/application/template/basket-6c253953714284eba3d0066a33257587.svg";